import styled from 'styled-components';
import { SpotifyReconnectModalStyle } from '../SpotifyReconnectModal/SpotifyReconnectModal.style';

/** Same shell as reconnect modal, but vertically centered instead of pinned to top. */
export const MfaEnrollmentModalStyle = styled(SpotifyReconnectModalStyle)`
  top: 0 !important;
  padding-bottom: 0;
`;
